import React from 'react'

import { IconProps } from '../types'

export const Search = ({ className, width = 16, height = 17, fill }: IconProps) => (
  <svg className={className} width={width} height={height} fill={fill} viewBox="0 0 16 17">
    <path d="m15.781 14.318-3.115-3.115a.75.75 0 0 0-.531-.219h-.51a6.468 6.468 0 0 0 1.375-4A6.498 6.498 0 0 0 6.5.486c-3.59 0-6.499 2.91-6.499 6.5s2.91 6.499 6.5 6.499c1.51 0 2.896-.512 4-1.375v.51c0 .2.078.39.218.53l3.116 3.116a.747.747 0 0 0 1.059 0l.884-.884a.753.753 0 0 0 .003-1.063Zm-9.28-3.334c-2.21 0-4-1.787-4-4a3.997 3.997 0 0 1 4-3.999c2.209 0 4 1.787 4 4 0 2.209-1.788 4-4 4Z" />
  </svg>
)
